// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--2DtNI";
export var hideInDesktop = "styles-module--hideInDesktop--A7ywO";
export var hideInMobile = "styles-module--hideInMobile--19_dY";
export var section = "styles-module--section--3MFx7";
export var sectionWrap = "styles-module--sectionWrap--9ftWG";